import styles from "@/styles/checkout-layout.module.scss"
import { useEffect } from "react"
import Link from 'next/link'
import { Image } from "antd"

import { loadMatomo } from "@/utils/matomo"
import { loadGtm } from "@/utils/gtm"
import { loadForter } from "@/utils/forter";

import loginApi from '@/service/modules/loginApi';

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain
import { useRouter } from 'next/router';
const apiDomain = publicRuntimeConfig.apiDomain;
interface LayoutProps {
  children: React.ReactNode;
}

export default function DefaultLayout(props: LayoutProps) {
  const currentYear = new Date().getFullYear(); // 获取当前年份

  // 请求me接口，这里需要登录（另外可以续命session）
  const renewalLoginStatus = async () => {
    try {
      const res = await loginApi.me()
      console.log(res, ' == user info');
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    function handleWindowLoad() {
      setTimeout(() => {
        renewalLoginStatus();
      }, 2000);

      loadMatomo()
      loadForter();
      // dataLayer数据需要先异步等待加载完成再执行，设置先不加载的白名单URL
      const whitelistPattern = /^(\/viewcart|\/payment-result|\/checkout\/bpay|\/online)/;
      if (!whitelistPattern.test(window.location.pathname)) {
        loadGtm(); // 如果不匹配，则加载 GTM
      }
    }

    window.addEventListener('load', handleWindowLoad);

    return () => {
      window.removeEventListener('load', handleWindowLoad);
    };
  }, []);

  const router = useRouter()
  // 请求接口，设置一些初始化的cookie
  const initCookie = async (aid: string | undefined, recoveraid: string | undefined) => {
    try {
      if (!aid && !recoveraid) return

      let fetchPath = `${apiDomain}/api/setCookie`
      if (aid) fetchPath = `${fetchPath}?aid=${aid}`
      if (recoveraid) fetchPath = `${fetchPath}?recoveraid=${recoveraid}`

      const response = await fetch(fetchPath, {
        method: 'GET',
        credentials: 'include',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json',
          'Accept': '*/*'
        },
        mode: 'cors'
      })

      if (!response.ok) {
        throw new Error('请求出错：' + response.statusText);
      }
    } catch (error) {
      return { notFound: true }
    }
  }

  useEffect(() => {
    const { aid, recoveraid }: any = router.query
    let lastAidValue = ''
    let lastRecoveraidValue = ''

    // 检查是否有"aid"参数，如有多个取最后
    if (Array.isArray(aid) && aid.length > 0) {
      lastAidValue = aid[aid.length - 1]
    } else if (typeof aid === 'string') {
      // 如果只有一个"aid"参数，它将是一个字符串
      lastAidValue = aid
    }

    // 检查是否有"recoveraid"参数，如有多个取最后
    if (Array.isArray(recoveraid) && recoveraid.length > 0) {
      lastRecoveraidValue = recoveraid[recoveraid.length - 1]
    } else if (typeof recoveraid === 'string') {
      // 如果只有一个"recoveraid"参数，它将是一个字符串
      lastRecoveraidValue = recoveraid
    }

    initCookie(lastAidValue, lastRecoveraidValue)
  }, [router.query])

  return (
    <div className={styles['checkout-layout']}>
      <div className={styles['header-box']}>
        <div className={styles['header']}>
          <div className={styles['left']}>
            <Link
              href={`/`}
              legacyBehavior
            >
              <a rel="noopener noreferrer">
                <Image src={`${imageDomain}/checkout/logo.svg`} width={203} preview={false} />
              </a>
            </Link>
          </div>
          <div className={styles['right']}>
            <Image src={`${imageDomain}/checkout/norton.png`} preview={false} className={styles['norton']} />
            <Image src={`${imageDomain}/checkout/compdp.png`} preview={false} className={styles['compdp']} />
          </div>
        </div>
      </div>

      <main className={styles['checkout-layout-container']}>
        {props.children}
      </main>

      <div className={styles['footer-box']}>
        Copyright &copy; 2007 - {currentYear} Crazy Sales. All rights reserved.ABN 66 166 623 169 | PO BOX 1016 Springvale, VIC 3171, Australia
      </div>
    </div>
  )
}